import { stdObject } from "../../../../data/types/stdObject";

export const totalCommFunc = (salesSection: stdObject) => {
  return "header" in salesSection
    ? salesSection.results.commissions.reduce(
        (acc: number, curr: stdObject) => (acc += Number(curr.PAGCOYP)),
        0,
      )
    : 0;
};
